import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container, Box } from '@mantine/core';
import { BlogList } from './BlogList';
import { BlogPost } from './BlogPost';
import { Header } from '../landing/Header';
import { AuthenticatedHeader } from '../landing/AuthenticatedHeader';
import { Footer } from '../landing/Footer';
import { useAuth } from '../UseAuthHook';
import { useNavigate } from 'react-router-dom';

export function BlogPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  
  // Function to handle scrolling to sections on the landing page
  const handleSectionScroll = (sectionId: string) => {
    navigate('/');
    // We need to wait for navigation to complete before scrolling
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  // Force header shadow in blog section for better visual separation
  const forceHeaderShadow = () => {
    // Find header elements and add shadow
    const headerElements = document.querySelectorAll('header');
    headerElements.forEach(header => {
      header.style.boxShadow = '0px 2px 10px rgba(0, 0, 0, 0.1)';
    });
  };

  // Apply shadow effect when component mounts
  React.useEffect(() => {
    forceHeaderShadow();
    // Small delay to ensure header is fully rendered
    const timer = setTimeout(forceHeaderShadow, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container fluid p={0} style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh' 
    }}>
      {isAuthenticated ? (
        <AuthenticatedHeader 
          onSortClick={() => navigate('/gallery')} 
          scrollToSection={(sectionId) => handleSectionScroll(sectionId)}
        />
      ) : (
        <Header 
          onLoginClick={() => navigate('/login')} 
          onRegisterClick={() => navigate('/signup')}
          scrollToSection={(sectionId) => handleSectionScroll(sectionId)} 
        />
      )}
      
      <Box style={{ 
        paddingTop: '60px',
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Routes>
          <Route path="/" element={<BlogList />} />
          <Route path="/:id" element={<BlogPost />} />
        </Routes>
      </Box>
      
      <Footer />
    </Container>
  );
}